module.exports = __webpack_public_path__ + "media/icons/instagram-9fb7e9f68a71e6e8f15b87a9c4a7b787.svg";